import { render, staticRenderFns } from "./adminComplaintList.vue?vue&type=template&id=26b73839&scoped=true"
import script from "./adminComplaintList.vue?vue&type=script&lang=js"
export * from "./adminComplaintList.vue?vue&type=script&lang=js"
import style0 from "./adminComplaintList.vue?vue&type=style&index=0&id=26b73839&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b73839",
  null
  
)

export default component.exports